import { getJson } from './http';
import type { AttendanceOverview } from '../../views/CompanyDashboard/types';

export async function fetchAttendanceOverview(params: { from?: string; to?: string; dept?: string; company?: string; scope?: 'personal' | 'team' | 'company' }, signal?: AbortSignal): Promise<AttendanceOverview> {
  // Always rely on real API; if it fails propagate the error for caller to handle (show error state/UI)
  return await getJson<AttendanceOverview>('/attendance/overview', params, signal);
}
